module.exports = __webpack_public_path__ + "img/IndustrialBlockchain.901ae018.png";